import { Element } from "react-scroll";
import React from "react";
import SectionOne from "./views/SectionOne";
import QuienesSomos from "./views/QuienesSomos";
import NuestrosServicios from "./views/NuestrosServicios";
import Opiniones from "./views/Opiniones";
import FormOpinion from "./views/FormOpinion";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Solicitar from "./views/Solicitar";

function App() {
	return (
		<div className="pt-12">
			<Header />
			<SectionOne />
			<Element name="servicios">
				<NuestrosServicios />
			</Element>
			<Element name="nosotros">
				<QuienesSomos />
			</Element>
			<Element name="opiniones">
				<Opiniones />
			</Element>
			<Element name="comenta">
				<FormOpinion />
			</Element>
			<Element name="solicitar">
				<Solicitar />
			</Element>
			<Footer />
		</div>
	);
}

export default App;
